import React, { useState } from "react";

import MdTrash from "react-ionicons/lib/MdTrash";
import Error from "../Error";
import ModalDelete from "../../common/ModalDelete";

import MdArrowUp from "react-ionicons/lib/MdArrowUp";
import MdArrowDown from "react-ionicons/lib/MdArrowDown";

const OptionForm = ({
  id,
  title,
  price,
  removeOption,
  optionIndex,
  extraIndex,
  register,
  errors,
  moveUp,
  canMoveUp,
  moveDown,
  canMoveDown,
}) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  var subtitle;

  const remove = () => {
    removeOption(optionIndex);
  };

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <form
      className="product-form flex border-2 border-gray-200 p-4 rounded-md mb-4 relative"
      id={id}
    >
      <ModalDelete
        message="¿Estás seguro que quieres borrar los datos de la opción?
                    Todos los datos serán perdidos permanentemente. Esta acción
                    no se puede revertir."
        closeModal={closeModal}
        modalIsOpen={modalIsOpen}
        remove={remove}
        shouldCloseOnEsc
        shouldCloseOnOverlayClick
        subtitle={subtitle}
        title="Borrar opción"
      ></ModalDelete>
      <div className="w-full">
        <div className="controls flex mb-2">
          {canMoveUp && (
            <button
              type="button"
              onClick={() => moveUp(optionIndex)}
              className="text-xs inline-flex items-center mr-2 bg-white rounded border py-1 px-3"
            >
              <MdArrowUp fontSize=".875rem" className="mr-1"></MdArrowUp> Mover
              un nivel arriba
            </button>
          )}
          {canMoveDown && (
            <button
              type="button"
              onClick={() => moveDown(optionIndex)}
              className="text-xs inline-flex items-center bg-white rounded border py-1 px-3"
            >
              <MdArrowDown fontSize=".875rem" className="mr-1"></MdArrowDown>{" "}
              Mover un nivel abajo
            </button>
          )}
        </div>

        <div className="mb-4 w-full input">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor={`extras[${extraIndex}].options[${optionIndex}].title`}
          >
            Nombre
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            name={`extras[${extraIndex}].options[${optionIndex}].title`}
            ref={register()}
            defaultValue={title}
            placeholder="Nombre de la opción"
          />
          <Error error={errors ? errors.title : null} left></Error>
        </div>
        <div className="mb-4 w-full input">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor={`extras[${extraIndex}].options[${optionIndex}].price`}
          >
            Precio
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="number"
            name={`extras[${extraIndex}].options[${optionIndex}].price`}
            ref={register()}
            defaultValue={price}
            placeholder="Precio de la opción"
          />
          <Error error={errors ? errors.price : null} left></Error>
        </div>
        <MdTrash onClick={openModal} className="trash"></MdTrash>
      </div>
    </form>
  );
};

export default OptionForm;
